<cl-menu [Id]="MenuId" [Logo]="Logo" [Title]="Title" [User]="User?.userName || 'Usuario'" [Nodes]="MenuNodes">
    <div class="exclude" style="width: 100%">
        <mat-toolbar class="toolbar-container fixed-header">
            <div class="mobile-title">
                <button mat-icon-button class="example-icon" (click)="ToggleMenu()">
                    <mat-icon class="custom mat-icon">menu</mat-icon>
                </button>
                <span class="toolbar-title">{{txtaccion}}</span>
            </div>
            <div class="app-header-elements">
                <ng-container>
                    <div class="avatar-container">
                        <mat-icon *ngIf="!userImageAvailable" class="custom mat-icon">account_circle</mat-icon>
                        <img *ngIf="userImageAvailable" [src]="userImageUrl" alt="User avatar" class="user-avatar"
                            (error)="handleImageError()">
                    </div>
                    <div class="user-text">
                        <span class="user-name">
                            {{User?.userName || 'Usuario'}} | {{User?.email || ''}}
                        </span>
                    </div>
                </ng-container>
            </div>
        </mat-toolbar>
        <router-outlet class="exclude"></router-outlet>
    </div>
</cl-menu>